import * as React from "react";

type Props = {
  children?: React.ReactNode;
};

const Wrapper = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <div ref={ref} {...props}>
      {props?.children}
    </div>
  );
});

export default Wrapper;